import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { ExtendsAttributesDto } from '../Mza/Service/Models/extendsattributesdto.entity';
import { Attribute } from '../entities/schema/attribute.entity';
import { GroupTreeAttribute } from '../entities/schema/grouptreeattribute.entity';
import { GroupTree } from '../entities/schema/grouptree.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class GroupTreeAttributeService extends ODataEntityService<GroupTreeAttribute> {
  constructor(protected client: ODataClient) {
    super(client, 'GroupTreeAttribute', 'entities.schema.GroupTreeAttribute');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  public getExtendsAttributes(): ODataFunctionResource<{id: number}, ExtendsAttributesDto> {
    const resource = this.entities().function<{id: number}, ExtendsAttributesDto>('services.GetExtendsAttributes');
    return resource;
  }
  //#endregion
  //#region ODataApi Navigations
  public attribute(entity: EntityKey<GroupTreeAttribute>): ODataNavigationPropertyResource<Attribute> {
    return this.entity(entity).navigationProperty<Attribute>('attribute');
  }
  public groupTree(entity: EntityKey<GroupTreeAttribute>): ODataNavigationPropertyResource<GroupTree> {
    return this.entity(entity).navigationProperty<GroupTree>('groupTree');
  }
  public status(entity: EntityKey<GroupTreeAttribute>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<GroupTreeAttribute>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
